import "./OnboardingCarousel.scss";

import { FC, ReactNode, useRef } from "react";
import Slider from "react-slick";

import { OnboardingCarouselCard } from "./OnboardingCarouselCard";
import { ArrowButton } from "../ArrowButton/ArrowButton";

interface ICarouselContent {
  title: string;
  subtitle: string | ReactNode;
  image: string;
}

interface IProps {
  content: ICarouselContent[];
}

export const OnboardingCarousel: FC<IProps> = ({ content = [] }) => {
  const sliderRef = useRef<Slider | null>(null);

  const sliderSettings = {
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 10000,
  };

  const nextSlide = () => {
    sliderRef.current && sliderRef.current.slickNext();
  };

  const prevSlide = () => {
    sliderRef.current && sliderRef.current.slickPrev();
  };

  return (
    <div className="onboarding-carousel__container">
      <div className="onboarding-carousel__wrapper">
        <Slider
          {...sliderSettings}
          dotsClass="slick-dots onboarding-carousel__dots"
          ref={sliderRef}>
          {content.map(item => (
            <OnboardingCarouselCard content={item} key={item.title} />
          ))}
        </Slider>

        <div className="onboarding-carousel__arrows">
          <ArrowButton className="prev--arrow" onClick={prevSlide} />
          <ArrowButton className="next--arrow" onClick={nextSlide} />
        </div>
      </div>
    </div>
  );
};
